import Footer from "./footer";
import Header from "./header";

export default function Layout({ children }: any) {
  return (
    <>
      <Header></Header>
      {children}
      <Footer></Footer>
    </>
  );
}
